const backendUrl = process.env.REACT_APP_BACKEND_URL?.trim().replace(/\/+$/, "");

if (!backendUrl) {
  throw new Error(
    "REACT_APP_BACKEND_URL is missing. Define it in frontend/.env and restart the frontend server."
  );
}

export const API_BASE_URL = `${backendUrl}/api`;

if (process.env.NODE_ENV === "development") {
  console.info(`[Drivault] API URL: ${API_BASE_URL}`);
}
